import React, { createRef } from 'react';

import { string, bool, shape, func } from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../.internal/BaseComponent';

import './Toggle.scss';

export default class Toggle extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      checked: props.defaultChecked,
      toggleWidth: undefined
    };
    this.offLabelRef = createRef();
    this.onLabelRef = createRef();
  }

  setToggleWidth = () => {
    const { current: offLabel } = this.offLabelRef;
    const { current: onLabel } = this.onLabelRef;

    offLabel.style.width = '';
    onLabel.style.width = '';

    const offLabelWidth = offLabel.offsetWidth;
    const onLabelWidth = onLabel.offsetWidth;

    const toggleWidth =
      onLabelWidth >= offLabelWidth ? onLabelWidth : offLabelWidth;

    this.setState({ toggleWidth });
  };

  componentDidMount() {
    this.setToggleWidth();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.offLabel !== prevProps.offLabel ||
      this.props.onLabel !== prevProps.onLabel
    ) {
      this.setToggleWidth();
    }
  }

  clickHandler = () => {
    const { onChange, checked } = this.props;
    const { checked: stateChecked } = this.state;
    const checkedValue = !(typeof checked !== 'undefined'
      ? checked
      : stateChecked);
    this.setState({ checked: checkedValue });
    if (typeof onChange !== 'undefined') {
      onChange(checkedValue);
    }
  };

  render() {
    const {
      id,
      className,
      disabled,
      onChange,
      checked,
      onLabel,
      offLabel,
      style: propsStyle
    } = this.props;
    const { checked: stateChecked, toggleWidth } = this.state;
    const { clickHandler } = this;

    const checkedValue =
      typeof checked !== 'undefined' ? checked : stateChecked;

    const toggleChecked = checkedValue ? 'toggle-checked' : '';

    const classNames = ClassNames('Toggle', className, toggleChecked);

    const onLabelClass = ClassNames(
      'onLabel',
      'text',
      '--xs',
      checkedValue ? 'checked' : ''
    );
    const offLabelClass = ClassNames(
      'offLabel',
      'text',
      '--xs',
      checkedValue ? '' : 'unchecked'
    );

    const labelStyle = {
      width: toggleWidth
    };

    const componentStyle = {
      ...labelStyle,
      ...propsStyle
    };

    return (
      <button
        type="button"
        style={componentStyle}
        id={id}
        className={classNames}
        disabled={disabled}
        onChange={onChange}
        onClick={clickHandler}
      >
        <div className="button__content">
          <div>
            <div
              className={onLabelClass}
              ref={this.onLabelRef}
              style={componentStyle}
            >
              {onLabel}
            </div>
            <div
              className={offLabelClass}
              ref={this.offLabelRef}
              style={componentStyle}
            >
              {offLabel}
            </div>
          </div>
        </div>
      </button>
    );
  }
}

Toggle.propTypes = {
  checked: bool,
  style: shape({}),
  id: string,
  className: string,
  disabled: bool,
  autoFocus: bool,
  onChange: func,
  defaultChecked: bool,
  onLabel: string,
  offLabel: string
};

Toggle.defaultProps = {
  checked: undefined,
  style: {},
  id: undefined,
  className: undefined,
  disabled: false,
  autoFocus: false,
  defaultChecked: false,
  onLabel: 'ON',
  offLabel: 'OFF'
};
